import { defaultCache } from '../cache';

const currentFeatureCodeKey = '__current_feature_code__';
const currentOktaClientCodeKey = '__current_okta_client_code__';

export const getCurrentFeatureCode = () => {
  return defaultCache.get<string>(currentFeatureCodeKey);
};

export const setCurrentFeatureCode = (
  productCode: string | null | undefined,
) => {
  defaultCache.set(currentFeatureCodeKey, productCode);
};

export const getCurrentOktaClientCode = () => {
  return defaultCache.get<string>(currentOktaClientCodeKey);
};

export const setCurrentOktaClientCode = (
  oktaClientCode: string | null | undefined,
) => {
  defaultCache.set(currentOktaClientCodeKey, oktaClientCode);
};

export const getSignInMountPath = () => {
  const signInUrl = '/login';
  return signInUrl;
};
